/*
 *
 *@description:订阅及取消订阅
 *@modifyContent:
 *@author: qiuhongyang
 *@date: 2020-07-28 17:34:25
 *
*/
import login from '../login';
import { FollowUser, FollowTopic } from "../apidata";

/**
 * 订阅及取消订阅
 * @param id jquery id '#media_list'
 * @param type 类型 1 文章  2 话题
 * @param arr 显示内容
 */
function subscribe(domId: string, type: number = 1, arr: string[] = ['订阅', '已订阅']): void {
    $(domId).on('click', '.btn_dy', async function (e) {
        // debugger;
        if ($(this).data("click")) { console.log(111); return false; }

        $(this).attr("data-click", 'true')

        //未登陆用户验证
        if (!login.login()) {
            $(this).removeAttr("data-click")
            return false;
        }
        //  防止多次点击

        let hasSub: boolean = $(this).hasClass("disabled"); //是否订阅

        let id: string = "";

        id = $(this).parents('.item').data(`${type == 1 ? 'uid' : 'account'}`);


        if (!id || !type) {
            $(this).removeAttr("data-click")
            return false;
        }

        let result: boolean;
        if (type == 1) {
            //个人
            result = await FollowUser(hasSub, id);
        } else {
            //话题
            result = await FollowTopic(hasSub, id)
        }
        //操作成功
        if (result) {
            let $item: JQuery = $(this).parents(".item");
            if (hasSub) {
                $item.find('.btn_dy').removeClass("disabled").html(arr[0]);
                $item.find(".user_modal").attr("data-dy", 1)
            } else {
                $item.find('.btn_dy').addClass("disabled").html(arr[1]);
                $item.find(".user_modal").attr("data-dy", 2)
            }
        }
        // console.log("end")
        $(this).removeAttr("data-click")
    })
}

export default subscribe;